import {
  CheckEligibilityPanel,
  CheckEligibilityPanelProps,
} from '../components/check-eligibility-panel/CheckEligibilityPanel'
import {
  EligibilityCheckResultPanel,
  EligibilityCheckResultPanelProps,
} from '../components/eligibility-check-result-panel/EligibilityCheckResultPanel'
import { HelloSpkBanner } from '../components/hello-spk-banner/HelloSpkBanner'
import { PageLayout } from '@/ui/layouts/PageLayout'

export type CheckEligibilityViewProps =
  | ({
      status: 'form'
    } & CheckEligibilityPanelProps)
  | ({
      status: 'result'
    } & EligibilityCheckResultPanelProps)

export function CheckEligibilityView(props: CheckEligibilityViewProps) {
  return (
    <PageLayout>
      <h1 className="typography-heading-1">Airdrop</h1>
      <div className="flex flex-col gap-4 lg:grid lg:grid-cols-[7fr_4fr] xl:grid-cols-[11fr_5fr]">
        <div className="lg:order-2">
          <HelloSpkBanner />
        </div>
        <div>
          {props.status === 'form' ? <CheckEligibilityPanel {...props} /> : <EligibilityCheckResultPanel {...props} />}
        </div>
      </div>
    </PageLayout>
  )
}
